// validation schema to be used with Formik for AddEnquiry component
import * as Yup from "yup";
import dayjs from "dayjs";

export const validationSchemaAdd = Yup.object().shape({
  category: Yup.string().required("Category is required"),
  description: Yup.string().required("Description is required"),
  expenseAmount: Yup.number()
    .typeError("Amount should be a number")
    .positive("Amount should be greater than 0")
    .required("Amount is required"),
  paymentMode: Yup.string().required("Payment mode is required"),
  date: Yup.mixed()
    .test(
      "is-date",
      "Date is invalid",
      (value) => dayjs(value).isValid() === true
    )
    .required("Next follow up date is required"),
});
